module.exports = __webpack_public_path__ + "static/media/01.8ebeb5e2.mp3";